<div class="login-main" *ngIf="!showTerms">    
    <div class="login-container">
        <div class="big-logo-container">
            <img class="big-logo" src="assets/imagenes/logo-app-big.webp">
        </div>
        <div class="login-content">        
            <mat-card style="display: contents;">
                <form [formGroup]="frmLogin" novalidate (ngSubmit)="login()">
                    <div class="logo-container">
                        <img class="logo" src="assets/imagenes/logo-coomeva.webp">
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field style="width: 100%;">                                
                                <mat-select name="docItem" formControlName="docType" placeholder="Tipo de Identificación">
                                @for (docItem of documentTypeData; track docItem) {
                                    <mat-option [value]="docItem.acronym">{{ docItem.acronym }} - {{ docItem.name}}</mat-option>
                                }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field style="width: 100%;">
                                <input autofocus type="text" matInput placeholder="Usuario" formControlName="docNumber">
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field style="width: 100%;">
                                <input [type]="hidePassword ? 'password' : 'text'" autocomplete="false" matInput placeholder="Contraseña" formControlName="password">
                                <mat-icon matSuffix (click)="hidePassword = !hidePassword" class="icon-button-style" [svgIcon]="iconName"></mat-icon>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-check">                        
                        <!--<a href="/forgetPassword" class="link-style">Recuperar contraseña</a> -->
                        <a (click)="initForgetPassword()" class="link-style">Recuperar contraseña</a>
                    </div>
                    <br>
                    <div class="btn-container">
                        <button type="submit" class="btn btn-primary" [disabled]="frmLogin.value.docNumber.length <= 0 || frmLogin.value.password.length <= 0">INGRESAR</button>
                    </div>
                </form>
            </mat-card>
        </div>   
    </div>
    <div class="message-container">
        <span class="message-span"> {{ loginMessage }} </span>
    </div>
</div>
<div *ngIf="showTerms">
    <mat-drawer-container class="component-container" hasBackdrop="true">
        <mat-drawer class="drawer-menu" #menuPanel mode="over">
          <!--<app-sidebar-menu #sidebarMenuComponent (click)="menuPanel.toggle()"></app-sidebar-menu> -->
        </mat-drawer>
        <mat-drawer-content>
          <div class="container-header">
              <mat-toolbar class="toolbar-header-static">
                <div class="menu-container">
                    <mat-icon class="icon-header" matTooltip="Atras" (click)="resetForm()">arrow_back_ios</mat-icon>
                </div>
                <div class="section-name-container">
                  <span class="section-title">
                    TÉRMINOS Y CONDICIONES
                  </span>
                  <span class="app-title">
                    OFICINA VIRTUAL DE
                    <span class="app-title-logo">
                      asesores
                    </span>
                  </span>
                </div>                
              </mat-toolbar>
          </div>      
        </mat-drawer-content>
    </mat-drawer-container>
    <div class="terms-main">
        <h2 style="font-family: MainFontBold;place-self: center;">TÉRMINOS Y CONDICIONES</h2>        
            <div class="ql-container ql-snow" style="border-width: 0; height: auto !important;">
                <div class="ql-editor" [innerHTML]="termsText" style="max-height: min-content;">
                </div>
            </div>
            <div class="ql-container ql-snow" style="border-width: 0; height: auto !important;">
                <div class="ql-editor" [innerHTML]="hdText" style="max-height: min-content;">
                </div>
            </div>        
        <div class="btn-container">
            <button type="submit" class="btn btn-primary" style="width: 10vw;" (click)="acceptTyC()">ACEPTAR TÉRMINOS Y CONDICIONES</button>
        </div>
    </div>
</div>